import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import SingleImageUploader from "../shared/imageUploaders/singleImage/SingleImageUploader";
import { Form, Input, Row, Col, Button, message, Spin } from "antd";
import axios from "axios";
import config from "../../config";

const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const safeGetItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem failed for key="${key}"`, e);
    return null;
  }
};

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem failed for key="${key}"`, e);
    return false;
  }
};

const safeSetJSON = (key, obj) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem(JSON) failed for key="${key}"`, e);
    return false;
  }
};

const UserForm = (props) => {
  const history = useHistory();

  // Profile Picture
  const [isLoading, setIsLoading] = useState(false);

  // Read user once, safely
  const storedUser = useMemo(
    () => safeJSONParse(safeGetItem("user"), {}), // ✅ Safe nested call
    []
  );

  const [logoUrl, setLogoUrl] = useState(
    props.edit ? (storedUser?.picture || "") : ""
  );

  const nickName = props.edit ? (storedUser?.nickname || "") : "";
  const userEmail = props.edit ? (storedUser?.email || "") : "";

  // Submission
  const onFinish = (values) => {
    setIsLoading(true);

    const doc = JSON.stringify({
      role: "user",
      nickname: values.displayName,
      email: values.email,
      picture: logoUrl,
      authorized: true,
    });

    const accessToken = safeGetItem("access_token"); // ✅ Safe access

    return axios
      .patch(
        `${config.USERS}/users`,
        {},
        {
          headers: {
            token: accessToken,
            doc: encodeURIComponent(doc),
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          if (props.edit) {
            message.success("You profile has been updated.");
          } else {
            message.success("You have been successfully registered as a User!");
          }

          const currentUser = safeJSONParse(safeGetItem("user"), {}) || {}; // ✅ Safe nested call
          const updatedUser = {
            ...currentUser,
            picture: logoUrl,
            nickname: values.displayName,
            email: values.email,
            role: "user",
          };

          safeSetItem("role", "user");
          safeSetJSON("user", updatedUser);

          history.push("/");
        } else {
          message.error(
            "Something went wrong, make sure you are connected to the internet."
          );
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Something went wrong updating your profile.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Navigation - Cancel Button
  const backToAccountTypesOptions = () => {
    let path = `/profile-start`;
    if (props.edit) path = "/";
    history.push(path);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Form
        name="userInfoForm"
        className="accountForm"
        onFinish={onFinish}
        layout="vertical"
        initialValues={{
          displayName: `${nickName}`,
          email: userEmail,
        }}
      >
        <Row gutter={[12]}>
          <Col span={24} style={{ marginBottom: "150px" }}>
            <SingleImageUploader
              handleImageUpload={(url) => setLogoUrl(url)}
              imagePreviewUrl={logoUrl}
              typeKey={"user"}
              title="Photo (optional)"
              layout={"logo"}
            />
          </Col>

          <Col span={24}>
            <Form.Item
              label="Display Name"
              name="displayName"
              rules={[
                {
                  required: true,
                  message: "Please enter display name",
                },
              ]}
            >
              <Input placeholder="Enter display name" disabled={isLoading} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Primary Email Address (not available to the public)"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter valid email",
                },
              ]}
            >
              <Input placeholder="Enter email" disabled={isLoading} />
            </Form.Item>
          </Col>

          <Col span={24} style={{ textAlign: "right" }}>
            <Form.Item>
              <Button
                className="btn-bordered"
                onClick={backToAccountTypesOptions}
                style={{ margin: "0px 5px", width: "85px" }}
                type="text"
                disabled={isLoading}
              >
                Cancel
              </Button>

              <Button
                className="btn-solid"
                htmlType="submit"
                style={{ margin: "0px 5px", width: "85px" }}
                type="text"
                disabled={isLoading}
              >
                {isLoading ? <Spin /> : "Save"}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UserForm;